/**
 * Unlock.tsx
 * ----------
 * Wi-Fi unlock page.
 * - Redirects to final test if user hasn't passed.
 * - Renders WifiUnlock instructions.
 */


import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useProgress } from '../../context/ProgressContext';
import WifiUnlock from './WifiUnlock';

const Unlock = () => {
  const { testPassed } = useProgress();
  const history = useHistory();

  useEffect(() => {
    if (!testPassed) {
      history.replace('/final-test');
    }
  }, [testPassed, history]);

  return (
    <section className="flex flex-col items-center 
    backdrop-blur-lg rounded-3xl shadow-2xl 
    min-h-full
    border border-blue-200 p-8 animate-fade-in">
      <WifiUnlock />
    </section>
  );
};

export default Unlock;
